<script lang="ts" setup>
  import { cva } from 'class-variance-authority'
  import type { ILinkButton } from '@/components/ui/link/types'
  import getLinkRel from '@/utils/getLinkRel'

  const props = withDefaults(defineProps<ILinkButton>(), {
    variant: 'primary',
    size: 'md',
    rounded: 'sm',
    target: '_blank'
  })

  const buttonBase = computed(() =>
    cva(
      'cursor-pointer focus-visible:ring-focus focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
      {
        variants: {
          variant: {
            primary: 'hover:bg-bt-green-hover bg-bt-green text-bt-blue-dark no-underline',
            secondary: 'bg-bt-blue-ui text-white hover:bg-bt-blue-ui-light no-underline',
            secondaryDark: 'bg-bt-blue-ui-dark text-white hover:bg-bt-blue-ui-dark no-underline',
            outline:
              'border-border border bg-transparent text-bt-blue-ui hover:bg-bt-blue-ui hover:text-white no-underline',
            secondaryOutline:
              'border-border border bg-transparent text-bt-blue-ui-dark hover:border-bt-blue-ui-dark hover:text-bt-blue-ui-dark transition-colors duration-300 no-underline',
            link: 'bg-transparent text-bt-blue-ui hover:text-bt-blue-ui-light'
          },
          rounded: {
            sm: 'rounded-sm',
            md: 'rounded-md',
            lg: 'rounded-lg',
            full: 'rounded-full'
          },
          size: {
            sm: 'py-1 px-4',
            md: 'py-2 px-4',
            lg: 'py-3 px-6'
          }
        }
      }
    )({
      variant: props.variant,
      size: props.size,
      rounded: props.rounded
    })
  )

  const rel = computed(() => props.rel ?? getLinkRel(props.target))
</script>

<template>
  <NuxtLink
    v-if="url !== ''"
    :to="url"
    :class="buttonBase"
    :target="target"
    :rel="rel ?? undefined"
  >
    <Icon
      v-if="icon"
      :name="icon"
      size="sm"
    />
    <span>{{ title }}</span>
  </NuxtLink>
</template>
